import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import styled from '@emotion/styled';

/**
 * ScrollToTop - Scrolls to top on route change
 *
 * Adapted from Marketing site's ScrollToTop component.
 */
const ScrollToTop: React.FC = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

/**
 * PublicLayout Component
 *
 * Sprint 041 Session 1: Layout wrapper for public/marketing pages.
 * Provides marketing-style header, footer, and scroll-to-top behavior.
 *
 * Used by:
 * - Marketing pages (/, /benefits, /features, etc.)
 * - Legal pages (/privacy, /terms)
 */
export const PublicLayout: React.FC = (): React.ReactElement => {
  return (
    <>
      <ScrollToTop />
      <PublicHeader />
      <MainContent>
        <Outlet />
      </MainContent>
      <PublicFooter />
    </>
  );
};

const MainContent = styled.main`
  min-height: 100vh;
`;
